import Vuex from 'vuex'
import Vue from 'vue'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'data-tables-store',
  storage: localStorage
})

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    displayFinishedProjects: false,
    currentFilterName: '',
    userDelimiter: ','
  },
  getters: {
    currentFilterName: state => state.currentFilterName,
    userDelimiter: state => state.userDelimiter,
    displayFinishedProjects: state => state.displayFinishedProjects
  },
  mutations: {
    setCurrentFilterName (state, newName) {
      state.currentFilterName = newName
    },
    setUserDelimiter (state, delimiter) {
      state.userDelimiter = delimiter
    },
    setDisplayFinishProjects (state, newValue) {
      state.displayFinishedProjects = newValue
    }
  },
  actions: {
    setCurrentFilterName (context, filterName) {
      context.commit('setCurrentFilterName', filterName)
    },
    setUserDelimiter (context, delimiter) {
      context.commit('setUserDelimiter', delimiter)
    },
    toggleDisplayFinishProjects ({ commit }, newValue) {
      commit('setDisplayFinishProjects', newValue)
    }
  }
})
